import { render, staticRenderFns } from "./CssGridItem.vue?vue&type=template&id=32a28fc3&"
import script from "./CssGridItem.vue?vue&type=script&lang=js&"
export * from "./CssGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports